import { put, takeLatest, call } from 'redux-saga/effects';
import axios from 'axios';
import {
  SEND_EMAIL,
  SAVE_MACRONUTRIENT_ANSWERS,
  GET_MACRONUTRIENT_ANSWERS,
  SAVE_MACRO_RESULTS,
  GET_MACRO_RESULTS,
} from './constants';
import {
  sendEmailSuccess,
  sendEmailError,
  saveMacronutrientAnswersSuccess,
  saveMacronutrientAnswersError,
  getMacronutrientAnswersSuccess,
  getMacronutrientAnswersError,
  saveMacroResultSuccess,
  saveMacroResultError,
  getMacroResultsSuccess,
  getMacroResultsError,
} from './actions';
import { normalizeError } from '../../helpers/utils';

// ✅ ADD THIS
const API_URL = process.env.REACT_APP_API_URL;

export function* sendEmail({ emailData, successMessage }) {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const body = JSON.stringify({ emailData });

  try {
    yield call(axios.post, emailData.url, body, config);
    yield put(sendEmailSuccess(successMessage));
  } catch (error) {
    yield put(sendEmailError('Error sending email, please try again later'));
    console.error('Error sending email:', error);
  }
}

export function* saveMacronutrientAnswers({ macronutrientAnswers }) {
  const token = localStorage.getItem('token');

  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-auth-token': token,
    },
  };

  const body = JSON.stringify({ macronutrientAnswers });

  try {
    // ✅ FIXED: Added API_URL and removed /api from path
    const payload = yield call(
      axios.post,
      `${API_URL}/users/macronutrient-answers`,
      body,
      config
    );
    yield put(saveMacronutrientAnswersSuccess(payload.data));

    // Reload user to get updated age, weight, gender fields
    yield put({ type: 'LOAD_USER' });
  } catch (error) {
    yield put(sendEmailError('Error sending email, please try again later'));
    yield put(saveMacronutrientAnswersError(error));
  }
}

export function* getMacronutrientAnswers() {
  try {
    // ✅ FIXED: Added API_URL and removed /api from path
    const payload = yield call(
      axios.get,
      `${API_URL}/users/macronutrient-answers`
    );
    yield put(getMacronutrientAnswersSuccess(payload.data));
  } catch (err) {
    console.log(err);
    yield put(getMacronutrientAnswersError(err));
  }
}

function* saveMacroResults({ macroResults, callback }) {
  try {
    // ✅ FIXED: Added API_URL and removed /api from path
    const response = yield call(axios.post, `${API_URL}/users/macro-results`, {
      macroResults,
    });
    yield put(saveMacroResultSuccess(response.data));

    if (callback) {
      callback(response.data._id);
    }
  } catch (error) {
    const errors = normalizeError(error);
    console.log(errors);
    yield put(saveMacroResultError(errors));
  }
}

function* getMacroResults() {
  try {
    // ✅ FIXED: Added API_URL and removed /api from path
    const response = yield call(axios.get, `${API_URL}/users/macro-results`);
    yield put(getMacroResultsSuccess(response.data));
  } catch (error) {
    const errors = normalizeError(error);
    console.log(errors);
    yield put(saveMacroResultError(errors));
  }
}

export default function* globalSaga() {
  yield takeLatest(SEND_EMAIL, sendEmail);
  yield takeLatest(SAVE_MACRONUTRIENT_ANSWERS, saveMacronutrientAnswers);
  yield takeLatest(GET_MACRONUTRIENT_ANSWERS, getMacronutrientAnswers);
  yield takeLatest(SAVE_MACRO_RESULTS, saveMacroResults);
  yield takeLatest(GET_MACRO_RESULTS, getMacroResults);
}
